import Area from '@/components/Area';
import { Canvas, useFrame } from '@react-three/fiber';
import * as React from 'react';
// import { Perf } from 'r3f-perf';
import * as THREE from 'three';
import { Detailed, Environment, Html, Hud, OrbitControls } from '@react-three/drei';
import { schemeSet1 } from 'd3-scale-chromatic';

// Create 800 objects with random position and rotation data
const positions = [...Array(800)].map(() => ({
  position: new THREE.Vector3(40 - Math.random() * 80, 40 - Math.random() * 80, 40 - Math.random() * 80),
  rotation: new THREE.Euler(Math.random() * Math.PI * 2, Math.random() * Math.PI * 2, Math.random() * Math.PI * 2),
}));

const LEVEL_OF_DETAILS = [0, 15, 25, 35, 100];
const LEVEL_OF_DETAILS_COUNT = LEVEL_OF_DETAILS.length - 1;
const COLOR_BY_LEVEL_OF_DETAIL = [...Array(LEVEL_OF_DETAILS_COUNT)].map((_, i) => schemeSet1[i]);

const OPACITY_BY_LEVEL_OF_DETAIL = [...Array(LEVEL_OF_DETAILS_COUNT)].map(
  (_, i) => (LEVEL_OF_DETAILS_COUNT - i) / LEVEL_OF_DETAILS_COUNT
);

// console.log(COLOR_BY_LEVEL_OF_DETAIL);

function Bust(props: Omit<React.ComponentProps<typeof Detailed>, 'distances' | 'children'>) {
  return (
    <Detailed distances={[0, 15, 25, 35, 100]} {...props}>
      {[
        ...COLOR_BY_LEVEL_OF_DETAIL.map((color) => (
          <group key={color}>
            <mesh>
              <boxGeometry args={[1, 1, 1]} />
              <meshStandardMaterial color={color} />
            </mesh>
          </group>
        )),
        <group />,
      ]}
      {/* $ts-ignore */}

      {/* {OPACITY_BY_LEVEL_OF_DETAIL.map((opacity) => (
        <group key={opacity.toString()}>
          <mesh>
            <boxGeometry args={[1, 1, 1]} />
            <meshStandardMaterial color="orange" transparent opacity={opacity} />
          </mesh>
        </group>
      ))} */}
    </Detailed>
  );
}

export type Props = {};

const SIZE = '40px';

function App01(props: Props) {
  const {} = props;

  return (
    <>
      <Area>
        {() => (
          <Canvas>
            <ambientLight intensity={1} />
            {/* <pointLight position={[0, 0, 0]} intensity={0.5} />
          <spotLight intensity={2.5} position={[50, 50, 50]} castShadow /> */}
            {/* <Perf position="top-right" /> */}
            {/* <R3fInfo /> */}
            {positions.map(({ position, rotation }, i) => (
              <Bust key={i} {...props} position={position} rotation={rotation} />
            ))}
            <OrbitControls />
            <Environment preset="city" />
            <axesHelper args={[100]} />
          </Canvas>
        )}
      </Area>
      <div className="flex">
        {/* {LEVEL_OF_DETAILS.map((level, i) => (
          <div key={i} style={{ backgroundColor: COLOR_BY_LEVEL_OF_DETAIL[i], width: '50px', height: '50px' }} />
        ))} */}
        {LEVEL_OF_DETAILS.map((level, i) => (
          <div
            key={i}
            className="relative"
            css={{ backgroundColor: COLOR_BY_LEVEL_OF_DETAIL[i], width: SIZE, height: SIZE }}
          >
            <div className="absolute text-black" css={{ top: '50%', left: '0.4rem', transform: 'translateY(-50%)' }}>
              {level}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default React.memo(App01);
